<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight my-content">
        <!-- 选项卡[[ -->
        <div class="g-tab">
            <a href="javascript:;" v-for="item in tabList" :key="item.curTab" @click="changeTab(item.curTab)">
                <div class="g-tab-item" :class="{'g-tab-item-active': item.curTab == curTab}">{{item.name}}</div>
            </a>
        </div>
        <!-- 选项卡]] -->
        <div>
            <!-- 项目管理 -->
            <manageProject v-show="curTab === 0" />
            <!-- 成片管理 -->
            <manageFinish v-show="curTab === 1" />
        </div>
    </div>
    <!-- 右边主体]] -->
</template>
<script>
import manageProject from './_manage_project.vue';
import manageFinish from './_manage_finish.vue';
export default {
    data() {
        return {
            tabList: [
                {
                    name: '项目管理', isActive: true, curTab: 0
                },
                {
                    name: '成片管理', isActive: false, curTab: 1
                }
            ],

            curTab: 0,
        }
    },
    components: {
        manageProject,
        manageFinish
    },
    activated() {
        this.curTab = this.getTabId();
    },
    methods: {
        getTabId() {
            return this.$route.query.tabId ? parseInt(this.$route.query.tabId) : 0;
        },
        changeTab(index) {
            this.curTab = index;
            this.$router.push({
                name: 'center-cme',
                query: {
                    tabId: index
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/manage/content.scss';
.my-content .freelance-list .operation .btn .g-btn {
    margin: 3px;
}
.list-empty {
    width: 100%;
    text-align: center;
    height: 300px;
    margin-top: 50px;
}
.js-open-reject {
    margin-left: 5px;
}
.operation {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-direction: column;
}
</style>
